export default __webpack_public_path__ + "static/media/iced-coffee.0dc2ddca.jpg";